import * as React from 'react';
import { PageSection, Title } from '@patternfly/react-core';

const GeneralSettings: React.FunctionComponent = () => (
  <PageSection>
    <Title headingLevel="h1" size="lg">
      General Settings Page Title
    </Title>
  </PageSection>
);

export { GeneralSettings };
